import { render, staticRenderFns } from "./depart-contact-editor.vue?vue&type=template&id=47ebb203&scoped=true&"
import script from "./depart-contact-editor.vue?vue&type=script&lang=js&"
export * from "./depart-contact-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ebb203",
  null
  
)

export default component.exports